import { call, put, takeLatest } from "redux-saga/effects";
import { InitAction, InvitationAction, ProjectSettingAction } from "../actions";
import * as types from "../actions/actionTypes";
import * as invitationApi from "../api/invitation";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherInvitation() {
  yield takeLatest(types.INVITATION_ACCEPT_REQUEST, workerAccept);
  yield takeLatest(types.INVITATION_REJECT_REQUEST, workerReject);
  yield takeLatest(types.SEND_SMS_REQUEST, workerSms);
  yield takeLatest(types.INVITE_REQUEST, workerInvite);
  yield takeLatest(types.CHECK_PHONE_NUMBER_REQUEST, workerCheckPhoneNumber);
  yield takeLatest(types.INVITATION_MAPSA_REQUEST, workerMapsaInvitation);
}

async function sendAcceptRequest(id) {
  return invitationApi.accept(id);
}
function* workerAccept(action) {
  try {
    const response = yield call(sendAcceptRequest, action.payLoad);
    yield put(
      InvitationAction.acceptSuccess(action.payLoad, response.data.data)
    );
  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });

    yield put(InvitationAction.acceptFailure(action.payLoad));
  }
}

async function sendRejectRequest(id) {
  return invitationApi.reject(id);
}
function* workerReject(action) {
  try {
    const response = yield call(sendRejectRequest, action.payLoad);
    yield put(
      InvitationAction.rejectSuccess(action.payLoad, response.data.data)
    );
  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });

    yield put(InvitationAction.rejectFailure(action.payLoad));
  }
}

async function sendSms(token) {
  return invitationApi.sendSms(token);
}
function* workerSms(action) {
  try {
    const response = yield call(sendSms, action.payLoad);
    yield put(InvitationAction.sendSmsSuccess(response.data));
    yield put(ProjectSettingAction.sharedContacts());
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(InvitationAction.sendSmsFailure(action.payLoad));
  }
}

async function invite(data) {
  return invitationApi.invite(data);
}
function* workerInvite(action) {
  try {
    const response = yield call(invite, action.payLoad);
    yield put(InitAction.getSuccess({ premium: response.data.premium }));
    yield put(InvitationAction.inviteSuccess(response.data));
    yield put(ProjectSettingAction.sharedContacts());
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(InvitationAction.inviteFailure(action.payLoad));
  }
}

async function checkPhoneNumber(data) {
  return invitationApi.checkPhoneNumber(data);
}
function* workerCheckPhoneNumber(action) {
  try {
    const response = yield call(checkPhoneNumber, action.payLoad);
    yield put(InvitationAction.checkPhoneNumberSuccess(response.data));
  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(InvitationAction.checkPhoneNumberFailure(error.response.data));
  }
}

function mapsaInvitation(data) {
  return invitationApi.mapsaInvite(data);
}

function* workerMapsaInvitation(action) {
  try {
    const response = yield call(mapsaInvitation, action.data);
    yield put(
      InvitationAction.mapsaInviteSuccess({
        data: response.data,
        phoneNumber: action.phoneNumber
      })
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(InvitationAction.mapsaInviteFailure());
  }
}
